import { message as Message } from 'antd';

/** @function */
export default Message;
